import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AppBar, Toolbar, Box, IconButton, Drawer, List, ListItem, ListItemText, Typography, Menu, MenuItem, Button } from "@mui/material";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import LanguageIcon from '@mui/icons-material/Language';
import Head from "./head";
import { useLanguage } from "../../../i18n/LanguageContext";

const Header = () => {
    const [sidebar, setSidebar] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const { lang, t, toggleLanguage } = useLanguage();
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 100);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const navLinks = [
        { title: t('common.home'), path: "/" },
        { title: t('common.about'), path: "/About" },
        { title: t('common.services'), path: "/blog" },
        { title: t('common.packs'), path: "/Pack" },
        { title: t('common.contact'), path: "/Contact" },
    ];

    const handleLangOpen = (event) => setAnchorEl(event.currentTarget);
    const handleLangClose = () => setAnchorEl(null);
    const handleLangSelect = (newLang) => {
        toggleLanguage(newLang);
        handleLangClose();
    };

    return (
        <>
            <Head />
            <AppBar
                position={scrolled ? "fixed" : "static"}
                color="inherit"
                elevation={scrolled ? 4 : 0}
                sx={{
                    transition: 'all 0.3s ease-in-out',
                    borderBottom: scrolled ? 'none' : '1px solid #CACACA',
                    backgroundColor: '#ffffff'
                }}
            >
                <Toolbar sx={{ justifyContent: "space-between", py: 1 }}>
                    <Box component={Link} to="/" sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                        <img src="./images/logopoly.jpg" alt="Polysoft Logo" style={{ width: "180px", height: "auto" }} />
                    </Box>

                    {/* Desktop Navigation */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 4 }}>
                        {navLinks.map((item) => (
                            <Typography
                                key={item.title}
                                component={Link}
                                to={item.path}
                                sx={{
                                    textDecoration: 'none',
                                    color: '#232836',
                                    fontWeight: 600,
                                    transition: 'color 0.2s',
                                    '&:hover': { color: '#DD8748' }
                                }}
                            >
                                {item.title}
                            </Typography>
                        ))}

                        <Button
                            onClick={handleLangOpen}
                            startIcon={<LanguageIcon />}
                            sx={{ color: '#1D2558', fontWeight: 600, textTransform: 'uppercase' }}
                        >
                            {lang}
                        </Button>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleLangClose}
                        >
                            <MenuItem onClick={() => handleLangSelect('fr')}>Français</MenuItem>
                            <MenuItem onClick={() => handleLangSelect('en')}>English</MenuItem>
                            <MenuItem onClick={() => handleLangSelect('ar')}>العربية</MenuItem>
                        </Menu>

                        <IconButton sx={{ color: '#DD8748', '&:hover': { backgroundColor: 'rgba(248, 158, 52, 0.1)' } }}>
                            <SearchOutlinedIcon />
                        </IconButton>
                    </Box>

                    {/* Mobile Navigation Toggle */}
                    <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', gap: 1 }}>
                        <Button
                            size="small"
                            onClick={() => {
                                if (lang === 'fr') toggleLanguage('en');
                                else if (lang === 'en') toggleLanguage('ar');
                                else toggleLanguage('fr');
                            }}
                            sx={{ color: '#1D2558', fontWeight: 700 }}
                        >
                            {lang.toUpperCase()}
                        </Button>
                        <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => setSidebar(true)}
                            sx={{ color: '#1D2558' }}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            {/* Mobile Drawer */}
            <Drawer anchor={lang === 'ar' ? 'left' : 'right'} open={sidebar} onClose={() => setSidebar(false)}>
                <Box sx={{ width: 250, p: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                        <IconButton onClick={() => setSidebar(false)} sx={{ color: '#1D2558' }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <List>
                        {navLinks.map((item) => (
                            <ListItem button key={item.title} component={Link} to={item.path} onClick={() => setSidebar(false)}>
                                <ListItemText
                                    primary={item.title}
                                    primaryTypographyProps={{ fontWeight: 600, color: '#232836' }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>
        </>
    );
};

export default Header;